var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _c(
        "h1",
        { staticClass: "font-semibold w-max-content custom-title mb-2" },
        [_vm._v("Postings")]
      ),
      _c("TabsWithRoutes", {
        staticClass: "mb-5",
        attrs: { routeTabs: _vm.routeTabs, navClass: "borderTabs" },
      }),
      _vm.companies
        ? _c("router-view", {
            attrs: { companies: _vm.companies, currentUser: _vm.currentUser },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }